'use client';
'use strict';

function createVarsResolver(resolver) {
  return resolver;
}

exports.createVarsResolver = createVarsResolver;
//# sourceMappingURL=create-vars-resolver.cjs.map
